import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { isUserLogged, resetUserLoggedData, storeUserLoggedData } from '../../services/storage'
import { fetchAuthSession, signIn, signOut } from "aws-amplify/auth";
import User from "../../model/User.model";
import { getCurrentUserInfo } from '../../services/auth';

// Define a type for the slice state
interface AuthState {
  is_logged: boolean
}

// Define the initial state using that type
const initialState: AuthState = {
  is_logged: isUserLogged(),
}

interface IPayloadLogin {
  email: string,
  password: string
}
export const loginUser = createAsyncThunk(
  "users/loginUser",
  async (values: IPayloadLogin, thunkAPI) => {
    try {
      // Login to Cognito AWS
      try {
        await signIn({ username: values.email, password: values.password })
      } catch (error:any) {
        if (error?.name !== "UserAlreadyAuthenticatedException") throw error
        await signOut()
        await signIn({ username: values.email, password: values.password })
      }
      // Get User Attribute
      const [currentUser, session] = await Promise.all([
        getCurrentUserInfo(),
        fetchAuthSession(),
      ])
      const accessToken = session.tokens?.accessToken
      if (!accessToken) throw new Error("Missing access token")
      const responseUser = User.factoryCognitoUser(currentUser.username, currentUser.attributes)
      // Store data locally
      storeUserLoggedData(accessToken.toString(), accessToken.payload.exp, responseUser)
      return responseUser
    } catch (e:any) {
      return thunkAPI.rejectWithValue({error: e})
    }
  }
)

export const logoutUser = createAsyncThunk(
  "users/logoutUser",
  async (values:void, thunkAPI) => {
    try {
      // Logout to Cognito AWS
      await signOut()
      return false;
    } catch (e:any) {
      console.log(e)
      return thunkAPI.rejectWithValue({error: e})
    } finally {
      // Reset data locally
      resetUserLoggedData()
    }
  }
)

export const authSlice = createSlice({
  name: 'auth',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
  },
  extraReducers:{
    [`${loginUser.fulfilled}`]: (state:AuthState, user: User) => {
      state.is_logged = true;
      return state;
    },
    [`${loginUser.rejected}`]: (state:any, error: any) => {
      state.is_logged = false;
      throw Error(error?.payload?.error?.message)
    },
    [`${logoutUser.fulfilled}`]: (state:AuthState, user: User) => {
      state.is_logged = false;
      return state;
    },
    [`${logoutUser.rejected}`]: (state:any, error: any) => {
      console.log(error)
      throw Error(error?.payload?.error?.message)
    },
  }
})

// export const { setIsLogged, setIsLoggedOut } = authSlice.actions

export default authSlice.reducer
